import * as planBuilder from './plan-builder';
import * as salesChannels from './sales-channels';
import * as settings from './settings';
import * as developer from './developer';
import * as productManager from './product-manager';
import * as targetContractValue from './target-contract-value';
import * as salesSettingsByArea from './sales-settings-by-area';
import * as salesSettingsByRep from './sales-settings-by-rep';
import * as repDetail from './rep-detail';
import * as planUpgradePath from './plan-upgrade-path';
import * as promoCode from './promo-code';
import * as editHistory from './edit-history';

import { AdminTools } from '@/modules/AdminTools';

export const adminToolPages = [
  planBuilder,
  productManager,
  settings,
  targetContractValue,
  salesSettingsByArea,
  salesSettingsByRep,
  planUpgradePath,
  salesChannels,
  developer,
  repDetail,
  promoCode,
  editHistory,
];

export const adminToolsRoutes = (protectedRoute, layout) => {
  const adminToolRoutes = (routes) => routes(protectedRoute, <AdminTools />);

  return {
    path: '',
    element: layout,
    children: adminToolPages.map(({ routes }) => adminToolRoutes(routes)),
  };
};
